
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Nav',
  inheritAttrs: false,
  props: {
    title: String,
  },
});
